import React, { useState } from "react";
export function PageDeleteData() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Solicitud de eliminación enviada para:", email);
        setMessage(
            "Hemos recibido tu solicitud. Nos pondremos en contacto pronto."
        );
        setEmail("");
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light py-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">
                        <div className="card border-0 shadow-lg rounded-lg">
                            <div className="card-header bg-primary text-white text-center border-0 py-4">
                                <i className="fas fa-shield-alt fa-3x mb-3"></i>
                                <h3 className="mb-0">
                                    Solicitud de Eliminación de Datos
                                </h3>
                            </div>

                            <div className="card-body p-4">
                                <div className="alert alert-info" role="alert">
                                    <i className="fas fa-info-circle mr-2"></i>
                                    Si deseas eliminar tus datos personales,
                                    completa el siguiente formulario. Nos
                                    pondremos en contacto contigo para procesar
                                    la solicitud.
                                </div>

                                <form onSubmit={handleSubmit} className="mt-4">
                                    <div className="form-group">
                                        <label className="form-label">
                                            <i className="fas fa-envelope mr-2"></i>
                                            Correo Electrónico
                                        </label>
                                        <input
                                            type="email"
                                            required
                                            className="form-control form-control-lg"
                                            placeholder="ejemplo@correo.com"
                                            value={email}
                                            onChange={(e) =>
                                                setEmail(e.target.value)
                                            }
                                        />
                                        <small className="text-muted">
                                            No compartiremos tu correo con
                                            terceros.
                                        </small>
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg btn-block mt-4"
                                    >
                                        <i className="fas fa-paper-plane mr-2"></i>
                                        Enviar Solicitud
                                    </button>
                                </form>

                                {message && (
                                    <div
                                        className="alert alert-success mt-4"
                                        role="alert"
                                    >
                                        <i className="fas fa-check-circle mr-2"></i>
                                        {message}
                                    </div>
                                )}
                            </div>

                            <div className="card-footer bg-white text-center border-0 py-3">
                                <small className="text-muted">
                                    <i className="fas fa-lock mr-2"></i>
                                    Sus datos están protegidos por nuestra
                                    política de privacidad
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
